export default __webpack_public_path__ + "static/media/congratsStar.05981827.svg";